import { Box, Button, ButtonProps, styled, Typography } from '@mui/material';
import { usePage } from './Hooks/usePage';
import ArrowBackSharpIcon from '@mui/icons-material/ArrowBackSharp';
import { useResponsive } from '../../hooks/useResponsive';

type DefaultPageProps = {
  children: React.ReactNode;
};

type ClickthroughPageProps = {
  actions: () => JSX.Element;
  children: React.ReactNode;
};

const BackButton = styled(Button)<ButtonProps>(({ theme }) => ({
  color: 'lightgray',
}));

const DefaultPage = ({ children }: DefaultPageProps) => {
  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        alignContent: 'center',
        alignItems: 'center',
        textAlign: 'center',
        gap: '40px',
      }}
    >
      <Box sx={{ paddingBottom: '24px' }}>
        <Typography variant='h5' color='primary'>
          TLA Click Through Guide
        </Typography>
      </Box>
      {children}
    </Box>
  );
};

const ClickthroughPage = ({ actions, children }: ClickthroughPageProps) => {
  const { prevPage, currentPage } = usePage();
  const { isMobile } = useResponsive();

  return (
    <DefaultPage>
      {children}

      <Box
        sx={{
          display: 'flex',
          gap: '15px',
          flexDirection: isMobile ? 'column' : 'row',
          width: isMobile ? '100%' : 'auto'
        }}
      >
        {actions()}
      </Box>

      <Box
        sx={{ width: '100%', display: 'flex', justifyContent: 'flex-start' }}
      >
        {currentPage !== 0 ? (
          <BackButton startIcon={<ArrowBackSharpIcon />} onClick={prevPage}>
            Back
          </BackButton>
        ) : null}
      </Box>
    </DefaultPage>
  );
};

export { ClickthroughPage, DefaultPage };
